// src/lib/mobileTableCards.js — 관리자 콘솔 표를 폰에서 «핵심 칸만 한 줄 목록»으로(2026-10-13 way · businweb #220 후속)
// ---------------------------------------------------------------------------
// 관리자 화면의 표는 열이 6~12개라 390px 폰에서 표 폭이 화면의 2~3배(노선 관리 1,203px ·
// 차량 관리 1,268px 실측)였다. 1차로 «행=카드»로 풀었으나 칸마다 한 줄씩 세로로 펼쳐져
// 노선 181개가 끝없이 길어졌다(way: 「펼쳐져서 정돈되지 않은 화면이 많다 · 리스트 형식으로」).
//
// 그래서 businweb `components/DataTable.tsx` 의 폰 규칙을 그대로 따른다:
//   · 표는 표 그대로(한 행 = 한 줄)
//   · `hide` = 폰에서 기본으로 뺄 칸(번호·코드·보조 정보)
//   · `pin`  = 왼쪽에 고정할 기준 칸(노선명·이름) — 옆으로 밀어도 어느 줄인지 보이게. 표마다 하나.
//   · PC 는 무시한다.
// buslink 표는 공용 컴포넌트가 아니라 화면마다 손으로 쓴 <table> 이라, 칸 지정을 표 안에 흩지 않고
// 여기 한 곳(PHONE_SPECS)에 «머리글 이름»으로 둔다. 표를 고칠 때 머리글을 바꾸면 이 표도 같이 볼 것.
// 🔴 colSpan>1 칸(빈 목록 안내·펼친 상세 행)은 손대지 않는다 — 숨기면 안내 문구가 사라진다.
// 🔴 스타일은 `src/styles/adminMobile.css` 가 `.bl-admin-m` 아래에서만 건다(PC 무영향).

// 표 판별 = 그 표에만 있는 머리글(`has` 전부 포함). 위에서부터 첫 일치.
export const PHONE_SPECS = [
  // 남기는 칸은 «390px 에 옆으로 밀지 않고 들어가는 것»까지만(2026-10-13 실측으로 정했다).
  // 정류장 칸(정류장 관리·경로 그리기)은 지도에 손으로 그리는 PC 작업이라 폰 목록에서 뺀다.
  { name: "노선 관리",     has: ["근무조", "좌석수"],      pin: "노선명",   hide: ["순서", "구분", "거래처", "근무조", "코드", "좌석수", "정류장"] },
  { name: "배차 관리",     has: ["출발시간", "차량번호", "기사"], pin: "노선명", hide: ["협력사", "차량번호"] },
  { name: "배차 일정",     has: ["요일", "제외"],          pin: "이름",     hide: ["협력사", "노선", "기사", "차량", "요일", "기간", "제외"] },
  { name: "기사 관리",     has: ["연락처"],                pin: "이름",     hide: ["사번", "차량번호", "상태"] },
  { name: "차량 관리",     has: ["모델명"],                pin: "차량번호", hide: ["차량ID", "위치방식", "모델명", "좌석수", "연식", "비고"] },
  { name: "협력사 관리",   has: ["업체코드", "업로드"],    pin: "업체명",   hide: ["업체코드", "상태", "유효기간", "업로드", "마지막 업로드"] },
  { name: "협력사 승객",   has: ["부서"],                  pin: "이름",     hide: ["사번", "부서"] },
  { name: "빈 차 확인",    has: ["확인 위치"],             pin: "노선",     hide: ["기사", "차량", "확인 위치", "방식"] },
  { name: "정류장별 탑승", has: ["순번", "정류장", "근접 거리"], pin: "정류장", hide: ["근접 거리"] },
  { name: "부정승차 요약", has: ["태깅 횟수"],             pin: "카드번호", hide: ["차량"] },
  { name: "부정승차 목록", has: ["카드번호", "시각"],      pin: "카드번호", hide: ["차량"] },
  // wrap = 띄어쓰기 없는 긴 값(「DMC래미안e.편한세상요진아파트(중)」)이 있는 칸만 글자 중간에서도 끊는다.
  // 🔴 모든 칸에 걸면 「오전 04:35:10」 같은 시각까지 쪼개진다(실측) — 칸을 지정할 것.
  { name: "탑승 명단",     has: ["시각", "사번", "이름"],  pin: "이름",     hide: ["사번", "협력사", "노선", "차량"], wrap: ["정류장"] },
  { name: "대시보드 거래처", has: ["오늘 배차", "업체코드"], pin: "거래처",  hide: ["노선", "업체코드"] },
];

export function headerLabels(table) {
  const head = table.tHead;
  if (!head || !head.rows.length) return [];
  const row = head.rows[head.rows.length - 1];
  const out = [];
  for (const th of row.cells) {
    const span = Math.max(1, th.colSpan || 1);
    // 정렬 머리글은 글자 옆에 ▲▼ 표시가 붙으므로 data-label(원래 머리글 이름)을 먼저 본다(2026-10-19).
    const text = ((th.dataset && th.dataset.label) || th.textContent || "").replace(/\s+/g, " ").trim();
    for (let k = 0; k < span; k++) out.push(text);
  }
  return out;
}

export function specFor(labels) {
  return PHONE_SPECS.find((s) => s.has.every((h) => labels.includes(h))) || null;
}

// 칸 번호별 역할: "pin" | "hide" | "wrap"(긴 값 중간 끊기) | ""(그대로)
export function phoneRoles(labels, spec) {
  if (!spec) return labels.map(() => "");
  const pinAt = labels.indexOf(spec.pin);
  const wrap = spec.wrap || [];
  return labels.map((l, i) => (i === pinAt ? "pin" : spec.hide.includes(l) ? "hide" : wrap.includes(l) ? "wrap" : ""));
}

function mark(el, role) {
  if (role) { if (el.dataset.phone !== role) el.dataset.phone = role; }
  else if (el.dataset.phone) delete el.dataset.phone;
}

// root 안의 표 전부에 data-mlist · th/td[data-phone] 을 단다. 바뀐 것만 쓴다.
export function labelTables(root) {
  if (!root) return;
  for (const table of root.querySelectorAll("table")) {
    const labels = headerLabels(table);
    if (!labels.length) { if (table.dataset.mlist) delete table.dataset.mlist; continue; }
    if (table.dataset.mlist !== "1") table.dataset.mlist = "1";
    const roles = phoneRoles(labels, specFor(labels));
    const head = table.tHead.rows[table.tHead.rows.length - 1];
    let hc = 0;
    for (const th of head.cells) { const s = Math.max(1, th.colSpan || 1); mark(th, s > 1 ? "" : roles[hc]); hc += s; }
    for (const body of table.tBodies) {
      for (const tr of body.rows) {
        let col = 0;
        for (const td of tr.cells) {
          const span = Math.max(1, td.colSpan || 1);
          mark(td, span > 1 ? "" : roles[col] || "");
          col += span;
        }
      }
    }
  }
}

// 화면이 바뀔 때(탭 전환·목록 갱신·행 펼침)마다 다시 단다.
// 🔴 콜백 안에서 바로 단다 — requestAnimationFrame 으로 미루면 탭이 가려진 사이 그 프레임이
//    안 와서 "예약됨" 표시만 남고 이후 표가 영영 표시 없이 남았다(2026-10-13 실측).
//    MutationObserver 는 이미 변경을 한 번에 모아 주고, 여기서 쓰는 건 속성(data-*)뿐이라
//    childList 를 안 건드려 자기 자신을 다시 깨우지 않는다.
export function observeTables(root) {
  if (!root || typeof MutationObserver === "undefined") return () => {};
  labelTables(root);
  const mo = new MutationObserver(() => labelTables(root));
  mo.observe(root, { childList: true, subtree: true, characterData: true });
  return () => mo.disconnect();
}
